import type { identifier } from '@core/models/base';

export const STUDIO_SHIPPING = 'Studio Shipping';
export interface ShippingOptionCreateModel {
  code: string;
  name: string;
  description: string;
  price: number;
  active: boolean;
  isEconomyShipping: boolean;
  allowsPOBox: boolean;
  sortIndex: number;
}

export interface ShippingOptionDisplayModel {
  id: identifier;
  code: string;
  name: string;
  description: string;
  price: number;
  active: boolean;
  isEconomyShipping: boolean;
  allowsPOBox: boolean;
  sortIndex: number;

  /**
   * Only set on the synthetic {@link STUDIO_SHIPPING} option: the job's resolved
   * "Ship Bulk Order To" recipient, already trimmed and defaulted server-side. Use this rather
   * than parsing it back out of {@link name}.
   */
  bulkOrderShipTo?: string;
}

export interface ShippingOptionUpdateModel {
  code: string;
  name: string;
  description: string;
  price: number;
  active: boolean;
  isEconomyShipping: boolean;
  allowsPOBox: boolean;
  sortIndex: number;
}

export enum ShippingOptions {
  MILITARY = 'priority',
}

/** USPS Priority Mail -- required for APO/FPO/DPO addresses. */
export const isMilitaryShippingOption = (option: { code?: string }): boolean =>
  option.code?.toLowerCase() === ShippingOptions.MILITARY;

/**
 * Whether an option belongs in shipping-set configuration.
 *
 * The military option is intentionally kept inactive so it never appears in a general shipping
 * list, but studios still price it per set, so it stays configurable regardless of that flag.
 */
export const isConfigurableInShippingSet = (option: { code?: string; active?: boolean }): boolean =>
  !!option.active || isMilitaryShippingOption(option);
